<div class="container-fluid p-0">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <button type="button" mat-raised-button class="m-1 mr-2" color="primary" (click)="onAddSSSPDoc()" matTooltip="Click this button to add a new document.">
      <mat-icon>add</mat-icon>
      Add Document
    </button>
  </nav>

  <mat-paginator class="my-2" #paginator1 [length]="listDataSource?.total | async" [pageSize]="listDataSource.limit" [pageSizeOptions]="listDataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>

  <app-sssp-doc *ngFor="let doc of listDataSource.connect() | async" [sssp_hash]="sssp.sssp_hash" [sssp_doc]="doc" [sssp]="sssp" (onDeleted)="onDeleted($event)"></app-sssp-doc>

  <mat-paginator class="my-2" #paginator2 [length]="listDataSource?.total | async" [pageSize]="listDataSource.limit" [pageSizeOptions]="listDataSource.pageSizeOptions" showFirstLastButtons></mat-paginator>
</div>
